import { PREVIEW_FLAGS, isPreviewEnabled } from './company-modules';

export function getCompanyMenuVersion(company) {
  return isPreviewEnabled(company, PREVIEW_FLAGS.MENU_V2) ? 2 : 1;
}
